module.exports = __webpack_public_path__ + "img/img-sol-img-05.ba859712.png";